<template>
  <a-space direction="vertical" style="width:100%" size="middle">
    <a-card :bordered="false">
      <a-space>
        <a-button type="primary" @click="openCreate">Добавить заказчика</a-button>
        <a-button @click="load" :loading="loading">Обновить</a-button>
      </a-space>
    </a-card>

    <a-card title="Заказчики" :bordered="false">
      <a-table :dataSource="rows" :columns="columns" :loading="loading" :pagination="false" rowKey="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'active'">
            <a-switch :checked="!!record.active" @change="toggleActive(record)" />
          </template>

          <template v-else-if="column.key === 'actions'">
            <a-button size="small" @click="openEdit(record)">Редактировать</a-button>
          </template>
        </template>
      </a-table>
    </a-card>

    <a-modal
      v-model:open="editOpen"
      :title="editing?.id ? 'Редактировать заказчика' : 'Новый заказчик'"
      @ok="save"
      :confirmLoading="saving"
    >
      <a-form layout="vertical">
        <a-form-item label="Название">
          <a-input v-model:value="form.name" />
        </a-form-item>

        <a-form-item label="Телефон">
          <a-input v-model:value="form.phone" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-space>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import {
  getKitchenContractors,
  createKitchenContractor,
  updateKitchenContractor,
  setKitchenContractorActive,
} from '../../api/contractors'

const loading = ref(false)
const saving = ref(false)
const editOpen = ref(false)
const rows = ref([])
const editing = ref(null)

const form = ref({
  name: '',
  phone: '',
  specials_mode: 'ADDITIONAL',
})

const columns = [
  { title: 'Название', dataIndex: 'name' },
  { title: 'Телефон', dataIndex: 'phone' },
  { title: 'Активен', key: 'active', width: 100 },
  { title: '', key: 'actions', width: 180 },
]

async function load() {
  loading.value = true
  try {
    const res = await getKitchenContractors()
    rows.value = res.data.data || []
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка загрузки')
  } finally {
    loading.value = false
  }
}

function openCreate() {
  editing.value = null
  form.value = {
    name: '',
    phone: '',
    specials_mode: 'ADDITIONAL',
  }
  editOpen.value = true
}

function openEdit(row) {
  editing.value = row
  form.value = {
    name: row.name || '',
    phone: row.phone || '',
    specials_mode: row.specials_mode || 'ADDITIONAL',
  }
  editOpen.value = true
}

async function save() {
  if (!form.value.name) {
    message.warning('Введите название')
    return
  }

  saving.value = true
  try {
    if (editing.value?.id) {
      await updateKitchenContractor(editing.value.id, form.value)
    } else {
      await createKitchenContractor(form.value)
    }
    editOpen.value = false
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка сохранения')
  } finally {
    saving.value = false
  }
}

async function toggleActive(row) {
  try {
    await setKitchenContractorActive(row.id, !row.active)
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка изменения активности')
  }
}

onMounted(load)
</script>
